import React from 'react';
import {
  AddConsultantButton,
  AddIcon,
  BackFullIcon,
  Container,
  Content,
  Header,
  HeaderActions,
  HeaderBack,
  HeaderInfo,
  HeaderTitle,
  LoadRow,
} from './styles';
import MenuBar from 'components/menu-bar';
import Search from 'components/search';
import { toast } from 'react-toastify';
import {
  Card,
  ControlledBoard,
  KanbanBoard,
  moveCard,
  OnDragEndNotification,
} from '@caldwell619/react-kanban';
import '@caldwell619/react-kanban/dist/styles.css';
import { useLocation, useParams } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import Load from 'components/load';
import { CONST_APPLICANT_KAMBAM_STEP } from 'utils/CONSTANTS';
import CardUserInfo from 'components/cards/user-info';
import CandidateModal from 'components/modais/applicant';
import { ApplicantCRUD } from 'services/requests/applicant';
import WarnModal from 'components/modais/warn';
import { ApplicantData } from 'services/requests/applicant/index.d';
import PDFmodal from 'components/modais/pdf';
import ManagePdfModal from 'components/modais/manage-pdf';

const applicantCRUD = new ApplicantCRUD();

const RecrutamentKambamPage: React.FC = () => {
  // Params
  const location = useLocation();
  const { id } = useParams();
  const { colors } = useTheme();
  const { name } = location.state || {};
  
  // Refs
  const isApiRunning = React.useRef(false);

  // States
  const [search, setSearch] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [currentClient, setCurrentClient] = React.useState<ApplicantData>();
  const [showModal, setShowModal] = React.useState(false);
  const [showManagePDF, setManagePDF] = React.useState(false);
  const [showWarn, setShowWarn] = React.useState(false);
  const [showDeleteOrTalent, setDeleteOrTalent] = React.useState(false);
  const [showMoveToPool, setMoveToPool] = React.useState(false);
  const [currentPdf, setCurrentPdf] = React.useState<number | undefined>();
  const [controlledBoard, setBoard] = React.useState<KanbanBoard<any>>({
    columns: [],
  });
  const [showPDF, setPDFModal] = React.useState(false);

  const handleCardMove: OnDragEndNotification<Card> = (
    _card,
    source,
    destination,
  ) => {
    setBoard(currentBoard => {
      if(destination?.toColumnId === 5 ) {
        if(!_card.id) {
          toast.error('Ocorreu um erro na seleção do aplicante');
        } else {
          setCurrentClient(_card as any)
          setMoveToPool(true)
        }
      } else {
        handleUpdateVancancie(Number(_card.id), Number(destination?.toColumnId));
      }
      return moveCard(currentBoard, source, destination);
    });
  };

  const refreshData = React.useCallback(async (page?: number) => {
    if (isApiRunning.current) return;
    try {
      isApiRunning.current = true;
      setLoading(true);
      const { data, status, error } = await applicantCRUD.read({
        page,
        per_page: 10,
        corporate_client_id: id
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        let currentData = KAMBAM_DATA;

        data.Applicant.forEach(item => {
          currentData.columns = currentData.columns.map(column => {
            if (column.title === item.kanban_step) {
              return {
                ...column,
                cards: [...column.cards, item],
              };
            } else if (item.kanban_step === null && column.id === 0) {
              return {
                ...column,
                cards: [...column.cards, item],
              };
            }
            return column;
          });
        });

        setBoard(currentData);
      }
    } catch (e) {
      alert(e);
    } finally {
      isApiRunning.current = false;
      setLoading(false);
    }
  }, []);

  const handleUpdateVancancie = React.useCallback(
    async (idCard: number, columnId: number) => {
      let kambamStep: string;
      let currentKambam: string;
      kambamStep = KAMBAM_DATA.columns[columnId].title;

      if (
        CONST_APPLICANT_KAMBAM_STEP.findIndex(
          item => item.label.toLowerCase() === kambamStep.toLocaleLowerCase(),
        ) >= 0
      ) {
        currentKambam =
          CONST_APPLICANT_KAMBAM_STEP[
            CONST_APPLICANT_KAMBAM_STEP.findIndex(
              item =>
                item.label.toLowerCase() === kambamStep.toLocaleLowerCase(),
            )
          ].keys;
      } else {
        currentKambam = kambamStep;
      }

      try {
        const {
          data,
          status: Status,
          error,
        } = await applicantCRUD.update({
          id: idCard,
          kanban_step: currentKambam,
        });

        if (error) throw new Error(error.message.description);
        if (Status === 200 && data) {
          toast('Passo no Kambam atualizado com sucesso.');
        }
      } catch (e) {
        alert(e);
      }
    },
    [],
  );

  const handleDeleteApplicant = React.useCallback(async (id: number) => {
    try {
      const { status, data, error } = await applicantCRUD.delete({ id });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        toast('Aplicante deletado com sucesso.');
      }
    } catch (e) {
      alert(e);
    } finally {
      setCurrentClient(undefined);
      setShowWarn(false);
    }
  }, []);

  const transferAplicantToPool = React.useCallback(async ({id} : { id : number}) => {
    if(!id) return

    const { status } = await applicantCRUD.moveTo({id})

    if(status === 200) {
      toast("Aplicante movido com sucesso")
      setCurrentClient(undefined);
      setMoveToPool(false);
      return;
    }
    toast.error("Ocorreu um erro no processo transferência.")
  }, [])

  const handleVisualizatePdf = React.useCallback(async ({id}: {id: number}) => {
      try {
        if(!id) throw new Error('Não foi possivel selecionar o currículo');
        setCurrentPdf(id)
        setPDFModal(true)
      } catch (e) {
        const { message } = e as Error;
        toast.error(message)
      } finally {
        //
      }
    }, []);
  React.useEffect(() => {
    refreshData();
  }, []);

  return (
    <Container>
      <MenuBar currentPage="Recrutamento" />
      <Content>
        <Header>
          <HeaderBack href="/recrutamento">
            <BackFullIcon />
          </HeaderBack>
          <HeaderInfo>
            <HeaderTitle>Recrutamento e seleção - {name}</HeaderTitle>
            <HeaderActions>
              <Search
                value={search}
                setValue={setSearch}
                placeholder="Pesquisar clientes"
              />
              <AddConsultantButton
                title="Adicionar cliente"
                iconRight={AddIcon}
                callback={() => setShowModal(true)}
              />
            </HeaderActions>
          </HeaderInfo>
        </Header>

        {loading ? (
          <LoadRow>
            <Load
              customStyle={{
                color: colors.secondaryDark,
              }}
              size="extraLarge"
            />
          </LoadRow>
        ) : (
          <>
            {controlledBoard.columns.length > 0 ? (
              <KambamStyles>
                <ControlledBoard
                  disableColumnDrag
                  allowAddCard={false}
                  allowAddColumn={false}
                  allowRenameColumn={false}
                  onCardDragEnd={handleCardMove}
                  onCardRemove={({ board, card, column }) => {
                  }}
                  allowRemoveColumn={false}
                  allowRemoveCard={false}
                  renderCard={(card: any, options) => (
                    <CardUserInfo
                      editCallback={() => {
                        let cardTs = card as any as ApplicantData
                        setCurrentClient(cardTs);
                        setShowModal(true);
                      }}
                      deleteCallback={() => {
                        let cardTs = card as any as ApplicantData
                        setCurrentClient(cardTs);
                        setShowWarn(true)
                      }}
                      customStyle={{marginRight:0}}
                      talentPool={{
                        name: card.name,
                        budget: card.budget,
                        email: card.email,
                        occupation: card.occupation,
                        image: card.image,
                        local: card.local,
                        id: 1,
                      }}
                      pdfCallback={() => {
                        setCurrentClient(card);
                        setManagePDF(true);
                      }}
                    />
                  )}>
                  {controlledBoard}
                </ControlledBoard>
              </KambamStyles>
            ) : (
              <HeaderTitle>Nenhum cliente cadastrado...</HeaderTitle>
            )}
          </>
        )}
      </Content>
      {showModal && (
        <CandidateModal
          onClose={() => {
            setShowModal(false);
          }}
          isApplicant
          talentPool={currentClient}
          corporateClientId={id}
        />
      )}
       {showWarn && (
        <WarnModal
          title="Remover Aplicante"
          description={`Certeza que quer remover o aplicante ${currentClient?.name}?`}
          confirmCallback={() => {
            setShowWarn(false);
            setDeleteOrTalent(true)
          }}
          declineCallback={() => {
            setCurrentClient(undefined);
            setShowWarn(false);
          }}
          declineButtonTitle='Não, manter.'
          confirmButtonTitle='Sim, remover.'
        />
      )}

       {showDeleteOrTalent && (
        <WarnModal
          title="Apagar ou Mover?"
          description={`Quer remover ou enviar para o banco de talentos o aplicante ${currentClient?.name}?`}
          confirmCallback={() => {
            handleDeleteApplicant(currentClient?.id || 0);
            setDeleteOrTalent(false);
            setShowWarn(false);
          }}
          declineCallback={() => {
            transferAplicantToPool({id: currentClient?.id || 0});
            setDeleteOrTalent(false);
            setShowWarn(false);
          }}
          declineButtonTitle='Mover'
          confirmButtonTitle='Apagar'
        />
      )}
       {showMoveToPool && (
        <WarnModal
          title="Mover para talentos?"
          description={`Tem certeza que quer mover o aplicante para o banco de talentos ?`}
          confirmCallback={() => {
            if(!currentClient) toast.error("Ocorreu um erro ao selelcionar o aplicante.")
            else transferAplicantToPool({ id: currentClient?.id })
            setCurrentClient(undefined);
            setMoveToPool(false);
          }}
          declineCallback={() => {
            setCurrentClient(undefined);
            setMoveToPool(false);
          }}
          declineButtonTitle='Não, manter.'
          confirmButtonTitle='Sim, mover.'
        />
      )}
      {showPDF && (
        <PDFmodal
          onClose={() => {
            setPDFModal(false);
            setCurrentClient(undefined);
          }}
          pdfId={currentPdf} // FIXME ajeitar corretamente a visualização
        />
      )}

      {showManagePDF && (
        <ManagePdfModal 
          userId={currentClient?.id}
          userName={currentClient?.name} 
          type='applicant' 
          onClose={() => {
            setManagePDF(false)
          }}
          onVisualizate={handleVisualizatePdf}
        />
      )}

    </Container>
  );
};

export default RecrutamentKambamPage;

const KambamStyles = styled('div')`
  flex: 1;
  display: flex;
  & * {
    /* font-family: 'Segoe' !important; */
  }
  & h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Inter' !important;
  }
  & .react-kanban-column {
    padding: 0;
    background-color: transparent;
    margin-right: 30px;
    &:nth-child(1) {
      & .react-kanban-column-header {
        background-color: #7f2c7c;
      }
    }
    &:nth-child(2) {
      & .react-kanban-column-header {
        background-color: #4a94f8;
      }
    }
    &:nth-child(3) {
      & .react-kanban-column-header {
        background-color: #56c991;
      }
    }
    &:nth-child(4) {
      & .react-kanban-column-header {
        background-color: #8075ff;
      }
    }
    &:nth-child(5) {
      & .react-kanban-column-header {
        background-color: #b55bcc;
      }
    }
    &:nth-child(6) {
      & .react-kanban-column-header {
        background-color: #FF0000;
      }
    }
    &:nth-child(7) {
      & .react-kanban-column-header {
        background-color: #bfb060;
      }
    }
    &:nth-child(8) {
      & .react-kanban-column-header {
        background-color: #ff72f1;
      }
    }
    &:nth-child(9) {
      & .react-kanban-column-header {
        background-color: #56c991;
      }
    }
  }
  & .react-kanban-column-header {
    border-radius: 5px;
    padding: 12px;
    margin-bottom: 25px;
    & span {
      color: white;
    }
  }
  & .react-kanban-card {
    margin-bottom: 20px;
  }
`;

const KAMBAM_DATA: {
  columns: {
    id: number;
    title: string;
    cards: any;
  }[];
} = {
  columns: [
    {
      id: 0,
      title: 'Recebimento de currículo',
      cards: [],
    },
    {
      id: 1,
      title: 'Entrevista por competência',
      cards: [],
    },
    {
      id: 2,
      title: 'Teste',
      cards: [],
    },
    {
      id: 3,
      title: 'Relatório',
      cards: [],
    },
    {
      id: 4,
      title: 'Entrevista técnica',
      cards: [],
    },
    {
      id: 5,
      title: 'Banco de talentos',
      cards: [],
    },
    {
      id: 6,
      title: 'Contratação',
      cards: [],
    },
  ],
};

export interface CustomCard extends Card {
  id: number;
  name: string;
  image: string | null;
  occupation: string;
  status: string;
  client_type: string;
  kanban_step: string;
  budget: string;
  cpf: string;
  local: string;
  advisor_relation: {
    id: number;
    image: string | null;
    name: string;
  } | null;
  vacancy_matching_quantity: number;
  onClick?: () => void;
}
